module.exports = __webpack_public_path__ + "img/priceConfig.a714535b.svg";